import { store } from '../../../src/store';
import {createApp} from 'vue'
import MicroModal from 'micromodal';
import { sendPetition } from '../../../src/js/scripts';
import Multiselect from '@vueform/multiselect';
import Vue from 'vue';
import vSelect from 'vue-select';
import Paginate from "vuejs-paginate-next";


import comarques from '../../../assets/data/municipalities.json';



if(document.querySelectorAll('.c-professionals-list').length > 0){
	//console.log('object exists');
	Array.from(document.querySelectorAll('.c-professionals-list')).forEach(element=>{
		var app_courses_module = createApp({
			data(){
				return {
					countOptions:[5,10,25,50,100],
					pageLoaded: false,
					id: "",
					tableOpen: false,
					selected_comarca: [],
					comarques_list: [],
					towns_list: [],
					full_professionals_list: [],
					current_professionals_list: [],
					paginated_matrix: [],
					displayed_professionals: [],
					formComarquesError: false,
					loading: false,
					list: undefined,
					currentPage: 1,
					totalPages: 0,
					itemsPerPage: 10,
					startingIndex: 0,
					endingIndex: 0,
					totalResultsInList: 0,
					searchTerm: '',
					paginationCondition: true,
					noComarques: false,
				}
			},
			components: {
				Multiselect,
				'v-select':vSelect,
				'paginate': Paginate,
			},
			mounted(){
				let mainElement = this.$refs.elementSection;
				this.id = mainElement.dataset['listId'];
				let url = '/wp-content/themes/cateb/src/services/lists/getLists.php'
					+"?list_id="+this.id
				sendPetition(url, (data)=>{
					console.log('data', data)
					if (data.lists.length > 0) {
						this.list = data.lists[0];
						this.comarques_list = this.list.comarques;
			
						this.full_professionals_list = this.list.professionals;
					
						this.current_professionals_list = this.full_professionals_list;
						this.generatePaginatedMatrix(this.current_professionals_list);
						if (this.comarques_list == null) {
							this.noComarques = true;
							this.tableOpen = true;
						}
						this.pageLoaded = true;
					}
				});
	
				if (localStorage.getItem('itemsPerPage')) {
					this.itemsPerPage = parseInt(localStorage.getItem('itemsPerPage'))
				}
	
			},
			watch:{
				selected_comarca(){
					if (this.selected_comarca.length === 0) {
						//this.tableOpen = false;
					}
				}
			},
			methods:{
				openModalIfUnlogged: function(event){
					this.url = event.target.closest('a').href;
					if(!this.clientLogged && !sessionStorage.getItem('loginStatus')){
						event.preventDefault();
						MicroModal.show('modal-login');
					}
				},
				filterProfessionals: function(event){
					event.preventDefault();
					this.loading = true;
					this.towns_list = [];
					let aux_comarques = [];
					if (this.selected_comarca.length > 0) {
						this.selected_comarca.forEach(comarca => {
							let comarca_towns = comarques.filter((ref_comarca)=>ref_comarca.name === comarca.toUpperCase())
							aux_comarques.push(comarca_towns[0])
						});
						aux_comarques.forEach(aux_com=>{
							this.towns_list.push(...aux_com.cities)
						})
						this.full_professionals_list = [];
						let rejects = [];
						this.list.professionals.forEach(prof=>{
							if (this.towns_list.filter(city=> this.normalizeStr(city.name) === this.normalizeStr(prof.city)).length > 0) {
								//console.log(prof.collegiatNumber);
								if (prof.collegiatNumber != null) {
									this.full_professionals_list.push(prof);
								}
							}else{
								if (this.normalizeStr(prof.city) == "l'hospitalet de llobregat" && this.towns_list.includes("L'Hospitalet del Llobregat")) {
									//console.log(prof.collegiatNumber);
									if (prof.collegiatNumber != null) {
										this.full_professionals_list.push(prof);
									}
								}else{
									rejects.push(prof);
								}
							}
						})
					}else{
						//console.log(this.list.professionals.filter(prof=>prof.collegiatNumber != null));
						this.full_professionals_list = this.list.professionals.filter(prof=>prof.collegiatNumber != null);
					}
					this.current_professionals_list = this.full_professionals_list;
					//console.log(this.current_professionals_list);
					this.generatePaginatedMatrix(this.current_professionals_list);
					this.loading = false;
					this.tableOpen = true;
				},
				normalizeStr: function(str){
					return str.toLowerCase().normalize('NFD').replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize()
				},
				searchTable: function(){
					let results_list = [];
					if (this.searchTerm.length > 0) {
						let terms = this.searchTerm.split(' ');
						terms = terms.filter(term=> term !== '');
						results_list = this.full_professionals_list.filter((person) => {
							let aux_person = {
								collegiatNumber: person.collegiatNumber,
								firstName: person.firstName,
								lastName: person.lastName,
								email: person.email,
								phone: person.phone,
							}
							let propertyValues = Object.values(aux_person);
							return propertyValues.some(prop => {
								let checks = []
								terms.forEach(term => {
									if (prop) {
										let aux_prop = this.removeAccents(prop).toLowerCase()
										let aux_term = this.removeAccents(term).toLowerCase()
										checks.push(aux_prop.includes(aux_term));
									}else{
										checks.push(false);
									}
								});
								return checks.includes(true);
							})
						});
						this.generatePaginatedMatrix(results_list);
						this.current_professionals_list = results_list;
						this.startingIndex = this.current_professionals_list.length > 0 ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
						this.endingIndex = Math.min((this.currentPage) * this.itemsPerPage, this.current_professionals_list.length);
						this.totalResultsInList = this.current_professionals_list.length;
					}else{
						this.current_professionals_list = this.full_professionals_list;
						this.generatePaginatedMatrix(this.current_professionals_list);
					}
				},
				changeNumberOfItemsPerPage: function($event){
					this.searchTerm = '';
					localStorage.setItem('itemsPerPage', this.itemsPerPage)
					this.generatePaginatedMatrix(this.current_professionals_list)
					this.changePage(1);
				},
				generatePaginatedMatrix: function(people_list) {
					this.currentPage = 1;
					this.paginated_matrix = this.listToMatrix(people_list, this.itemsPerPage);
					if (this.paginated_matrix) {
						this.displayed_professionals = this.paginated_matrix[this.currentPage - 1];
						this.startingIndex = this.current_professionals_list.length > 0 ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
						this.endingIndex = Math.min((this.currentPage) * this.itemsPerPage, this.current_professionals_list.length);
						this.totalResultsInList = this.current_professionals_list.length;
					}
					this.paginationCondition = this.paginated_matrix.length > 1;
				},
				changePage: function(pageNumber){
					this.currentPage = pageNumber;
					this.displayed_professionals = this.paginated_matrix[this.currentPage - 1];
					let list = this.paginated_matrix
					this.startingIndex = this.current_professionals_list.length > 0 ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
					this.endingIndex = Math.min((this.currentPage) * this.itemsPerPage, this.current_professionals_list.length);
					this.totalResultsInList = this.current_professionals_list.length;
				},
				listToMatrix: function(list, elementsPerSubArray) {
					var matrix = [], i, k;
				
					for (i = 0, k = -1; i < list.length; i++) {
						if (i % elementsPerSubArray === 0) {
							k++;
							matrix[k] = [];
						}
				
						matrix[k].push(list[i]);
					}
				
					return matrix;
				},
				removeAccents: function (string) {
					return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
				}
			}
		}).mount(element);
	})
} 